import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 536px;
  border-radius: 12px;
  background: white;
  padding: 40px;
  position: relative;
`;

export const CloseButton = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding-top: ${(props) => (props.showDottedBorder ? '0' : '20px')};
`;

export const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
`;

export const Title = styled.h2`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #1a1a1a;
  margin: 0;
  text-align: center;
`;

export const Message = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #1a1a1a;
  margin: 0;
  text-align: center;
`;

export const EmailList = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: #1a1a1a;
  margin: 0;
  text-align: center;
`;

export const ActionButton = styled.button`
  padding: 8px 16px;
  border-radius: 20px;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 16px;
  cursor: ${(props) => (props.nonClickable ? 'default' : 'pointer')};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;

  ${(props) => {
    if (props.primary) {
      return `
        background: var(--color-purple-300, #7200E0);
        color: white;
        border: 1px solid #7200E0;
        &:hover {
          background-color: ${props.nonClickable ? 'var(--color-purple-300, #7200E0)' : '#7C3AED'};
        }
      `;
    }
    if (props.secondary) {
      return `
        background: transparent;
        color: var(--color-purple-300, #7200E0);
        border: 1px solid #7200E0;
        &:hover {
          opacity: ${props.nonClickable ? '1' : '0.8'};
        }
      `;
    }
    if (props.danger) {
      return `
        background: transparent;
        color: #DC2626;
        border: 1px solid #DC2626;
        &:hover {
          opacity: ${props.nonClickable ? '1' : '0.8'};
        }
      `;
    }
    return `
      background: var(--color-purple-300, #7200E0);
      color: white;
      &:hover {
        background-color: ${props.nonClickable ? 'var(--color-purple-300, #7200E0)' : '#7C3AED'};
      }
    `;
  }}
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  align-self: flex-start;
  padding-left: 0;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--color-purple-300, #7200E0);
`;

export const CheckboxLabel = styled.label`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #666;
  cursor: pointer;
  user-select: none;
`;

export const ArrowIcon = styled.svg`
  margin-left: 8px;
`;
